export default __webpack_public_path__ + "static/media/William Turner 27.d0951c3e.png";